import { render, staticRenderFns } from "./ContactBlock.vue?vue&type=template&id=963a2312&scoped=true&"
import script from "./ContactBlock.vue?vue&type=script&lang=js&"
export * from "./ContactBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContactBlock.vue?vue&type=style&index=0&id=963a2312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963a2312",
  null
  
)

export default component.exports